import { render } from "./CmsStories.vue?vue&type=template&id=5316cf0e&lang=html"
import script from "./CmsStories.vue?vue&type=script&lang=js"
export * from "./CmsStories.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__